export const UPGRADE_PLAN_TITLE = 'Upgrade';

export const RENEW_SUBSCRIPTION_ACTION = 'renew';
export const RENEW_INACTIVE_SUBSCRIPTION_ACTION = 'renewInactive';
export const ADD_SUBSCRIPTION_ACTION = 'add';
